export default "__VITE_ASSET__QwX1WwvF__"